import { useState } from "react";

import Box from "ds/components/Box";
import TabPanel from "ds/components/TabPanel";
import useTypedContext from "hooks/useTypedContext";

import DashboardWidgetsOpenTofuMigration from "../../OpenTofuMigration";
import { OpenTofuMigrationContext } from "../../OpenTofuMigration/context";
import DashboardWidgetsStacksRequiringAttention from "../../StacksRequiringAttention";
import { StacksRequiringAttentionContext } from "../../StacksRequiringAttention/context";
import { VendorMigrationTab } from "../types";
import DashboardWidgetsVendorMigrationSuccess from "./Success";
import DashboardWidgetsVendorMigrationTabs from "./Tabs";

const DashboardWidgetsVendorMigrationTabbedVendors = () => {
  const [selectedTab, setSelectedTab] = useState(VendorMigrationTab.OpenTofu);

  const terragrunt = useTypedContext(StacksRequiringAttentionContext);
  const openTofu = useTypedContext(OpenTofuMigrationContext);

  const isSuccess = openTofu.isEmpty && terragrunt.isEmpty;

  return (
    <Box direction="column" gap="large" fullWidth>
      <DashboardWidgetsVendorMigrationTabs
        selectedTab={selectedTab}
        onSelect={setSelectedTab}
        counts={{
          [VendorMigrationTab.OpenTofu]: openTofu.eligibleToMigrate,
          [VendorMigrationTab.Terragrunt]: terragrunt.readyToMigrate,
        }}
      />

      {isSuccess && <DashboardWidgetsVendorMigrationSuccess />}

      {!isSuccess && (
        <>
          <TabPanel
            fullWidth
            id={VendorMigrationTab.OpenTofu}
            isActive={selectedTab === VendorMigrationTab.OpenTofu}
          >
            <DashboardWidgetsOpenTofuMigration />
          </TabPanel>
          <TabPanel
            fullWidth
            id={VendorMigrationTab.Terragrunt}
            isActive={selectedTab === VendorMigrationTab.Terragrunt}
          >
            <DashboardWidgetsStacksRequiringAttention />
          </TabPanel>
        </>
      )}
    </Box>
  );
};

export default DashboardWidgetsVendorMigrationTabbedVendors;
